import React, { useContext} from 'react'
import { AppContext } from '../stores/AppStore'

const Login = () => {
  const { redirectUrl } = useContext(AppContext)
  window.location.href = `${process.env.REACT_APP_LOGIN_URL}${redirectUrl ? `?redirectTo=${redirectUrl}` : ''}`
  return <></>
}

export default Login